"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _root_model = _interopRequireDefault(require("./root_model"));
var _level = _interopRequireDefault(require("./level"));
var _image = _interopRequireDefault(require("./image"));
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ConceptBasic = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function ConceptBasic() {
    var _this;
    _classCallCheck(this, ConceptBasic);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ConceptBasic, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "name", _descriptor2, _this);
    _initializerDefineProperty(_this, "abbreviation", _descriptor3, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor4, _this);
    _initializerDefineProperty(_this, "vocab", _descriptor5, _this);
    _initializerDefineProperty(_this, "lesson", _descriptor6, _this);
    _initializerDefineProperty(_this, "grammarTense", _descriptor7, _this);
    _initializerDefineProperty(_this, "loopSupplement", _descriptor8, _this);
    _initializerDefineProperty(_this, "featured", _descriptor9, _this);
    _initializerDefineProperty(_this, "showAsConcept", _descriptor0, _this);
    _initializerDefineProperty(_this, "showInDictionary", _descriptor1, _this);
    _initializerDefineProperty(_this, "published", _descriptor10, _this);
    _initializerDefineProperty(_this, "pinned", _descriptor11, _this);
    _initializerDefineProperty(_this, "joinType", _descriptor12, _this);
    _initializerDefineProperty(_this, "grammarCase", _descriptor13, _this);
    _initializerDefineProperty(_this, "score", _descriptor14, _this);
    _initializerDefineProperty(_this, "infinitive", _descriptor15, _this);
    _initializerDefineProperty(_this, "showAsInfinitive", _descriptor16, _this);
    _initializerDefineProperty(_this, "showAsWordType", _descriptor17, _this);
    _initializerDefineProperty(_this, "icon", _descriptor18, _this);
    _initializerDefineProperty(_this, "displayNameLine1", _descriptor19, _this);
    _initializerDefineProperty(_this, "displayNameLine2", _descriptor20, _this);
    _initializerDefineProperty(_this, "sentencesCount", _descriptor21, _this);
    _initializerDefineProperty(_this, "wordsCount", _descriptor22, _this);
    _initializerDefineProperty(_this, "hasAllVideoClips", _descriptor23, _this);
    _initializerDefineProperty(_this, "showOnGenderCard", _descriptor24, _this);
    _initializerDefineProperty(_this, "showOnPluralCard", _descriptor25, _this);
    _initializerDefineProperty(_this, "longDescriptionMd", _descriptor26, _this);
    _initializerDefineProperty(_this, "longDescription", _descriptor27, _this);
    _initializerDefineProperty(_this, "shortDescription", _descriptor28, _this);
    _initializerDefineProperty(_this, "conceptCategoryId", _descriptor29, _this);
    _initializerDefineProperty(_this, "groupId", _descriptor30, _this);
    _initializerDefineProperty(_this, "level", _descriptor31, _this);
    _initializerDefineProperty(_this, "image", _descriptor32, _this);
    return _this;
  }
  _inherits(ConceptBasic, _RootModel);
  return _createClass(ConceptBasic, [{
    key: "displayNameLine1WithCase",
    get: function get() {
      if ((0, _utils.isPresent)(this.displayNameLine1) && this.languageId === 'DE') {
        return (0, _lodash.compact)([this.displayNameLine1, this.caseName]).join(', ');
      } else if ((0, _utils.isPresent)(this.displayNameLine1)) {
        return this.displayNameLine1;
      }
      return this.name;
    }
  }, {
    key: "caseName",
    get: function get() {
      var _this2 = this;
      var myCase = _constants.Constants.CASES.find(function (item) {
        return item.abbreviation === _this2.grammarCase;
      });
      if (myCase && myCase.name === 'None' && this.languageId === 'DE') {
        return 'No Case';
      }
      if (myCase) {
        return "".concat(myCase.name, " Case");
      }
      return null;
    }
  }, {
    key: "imageUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.image) ? this.image.url : null;
    }
  }, {
    key: "isDative",
    get: function get() {
      return this.grammarCase === 'Dt' || this.grammarCase === '2w-Dt';
    }
  }, {
    key: "isAccusative",
    get: function get() {
      return this.grammarCase === 'Ak' || this.grammarCase === '2w-Ak';
    }
  }, {
    key: "isNominative",
    get: function get() {
      return this.grammarCase === 'Nm';
    }
  }, {
    key: "isGenitive",
    get: function get() {
      return this.grammarCase === 'Gn';
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "vocab", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "lesson", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "grammarTense", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "loopSupplement", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "featured", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "showAsConcept", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "showInDictionary", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "published", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "pinned", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "joinType", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "grammarCase", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "score", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "infinitive", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showAsInfinitive", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "showAsWordType", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "icon", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "displayNameLine1", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "displayNameLine2", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "sentencesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "wordsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "hasAllVideoClips", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "showOnGenderCard", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "showOnPluralCard", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "longDescriptionMd", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "longDescription", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "shortDescription", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "conceptCategoryId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "groupId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "image", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _class);
var _default = exports["default"] = ConceptBasic;